export enum CustomerField {
    CUSTOMER_NUMBER = "customerNumber",
    NAME = "name",
    ORGANIZATION_ID = "organizationId",
    NAME_MISMATCH = "nameMismatch",
    NAME_ASSOCIATED_WITH_NUMBER = "nameAssociatedWithNumber",
}

export interface Customer {
    [CustomerField.CUSTOMER_NUMBER]: number;
    [CustomerField.NAME]: string;
    [CustomerField.ORGANIZATION_ID]?: string;
    [CustomerField.NAME_MISMATCH]: boolean;
    [CustomerField.NAME_ASSOCIATED_WITH_NUMBER]?: string;
}
